<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import Input from '$components/Form/Input.svelte';
    import Select from '$components/Form/Select.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const mainNeedOptions = [
        `Installation climatisation`,
        `Entretien / maintenance`,
        `Réparation / dépannage`,
        `Chambre froide / froid industriel`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const buildingTypeOptions = [
        `Résidentiel`,
        `Bureau / commerce`,
        `Site industriel`,
        `Hôtel / restaurant`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const projectTimelineOptions = [
        `Le plus tôt possible`,
        `Dans moins d'un mois`,
        `Dans 1 à 3 mois`,
        `Ce n'est qu'un projet pour le moment`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.froidClimatisation.mainNeed}
        class=""
        let:field
        let:id
        label={`Quel est votre besoin principal ?`}
        helpLabel="Maximum 2"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            max={2}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={mainNeedOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.froidClimatisation.buildingType}
        class=""
        let:field
        let:id
        label={`Quel type de bâtiment est concerné ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={buildingTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.froidClimatisation.surfaceArea}
        class=""
        let:field
        let:id
        label={`Quelle est la surface approximative du lieu concerné en m2 ?`}
    >
        <div class="flex items-center gap-2">
            <Input
                {form}
                {field}
                {id}
                toText={(id) => id}
                fromText={(id) => id}
                type="text"
                placeholder="Surface"
                class="flex-grow"
            />
            <span class="control-form w-fit font-bold">m²</span>
        </div>
    </Row>

    <Row
        {form}
        field={fields.froidClimatisation.city}
        class=""
        let:field
        let:id
        label={`Quel est la ville de l'intervention ?`}
    >
        <Input
            {form}
            {field}
            {id}
            toText={(id) => id}
            fromText={(id) => id}
            type="text"
            placeholder="Ville"
        />
    </Row>

    <Row
        {form}
        field={fields.froidClimatisation.projectTimeline}
        class=""
        let:field
        let:id
        label={`Quand souhaitez-vous réaliser ce projet ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={projectTimelineOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
